import { render } from "./OdometerLogs.vue?vue&type=template&id=2cf12a0a"
import script from "./OdometerLogs.vue?vue&type=script&lang=js"
export * from "./OdometerLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__